import { cn } from "@/zapi-frontend/shared/lib/utils";
import { InnoveraIcon } from "@libs/zapi-ui/assets";
import { InnoveraGlyph } from "./InnoveraGlyph";

type TAvatarAiProps = {
  state?: "default" | "error";
  variant?: "filled" | "outlined";
  className?: string;
};

export function AvatarAi({ state = "default", variant = "filled", className }: TAvatarAiProps) {
  const isOutlined = variant === "outlined" && state !== "error";

  return (
    <div
      className={cn(
        "flex size-[30px] shrink-0 items-center justify-center rounded-full",
        state === "error"
          ? "bg-innoveraRed-50"
          : isOutlined
            ? "border border-innoveraZinc-150 bg-white"
            : "bg-innoveraZinc-100",
        className
      )}
    >
      {isOutlined ? (
        <InnoveraIcon className="size-[14px] text-innoveraZinc-900" />
      ) : (
        <InnoveraGlyph
          className={cn("size-[18px]", state === "error" ? "text-innoveraRed-400" : "text-innoveraZinc-500")}
        />
      )}
    </div>
  );
}
